// Enums from backend, by type of system fields
export const SYSTEM_FIELD_TYPE_TEXT = 'string'
export const SYSTEM_FIELD_TYPE_STRING = 'string'
export const SYSTEM_FIELD_TYPE_LIST = 'list'
export const SYSTEM_FIELD_TYPE_MULTIPLE = 'multiple'
export const SYSTEM_FIELD_TYPE_BOOLEAN = 'boolean'
export const SYSTEM_FIELD_TYPE_DATE = 'date'
export const SYSTEM_FIELD_TYPE_FILE = 'attachment'

// Field types used in the frontend, mapped from form builder types.
export const SYSTEM_FIELD_FORM_BUILDER_TYPE_TEXT = 'text'
export const SYSTEM_FIELD_FORM_BUILDER_TYPE_SELECT = 'select'
export const SYSTEM_FIELD_FORM_BUILDER_TYPE_MULTI_SELECT = 'multi-select'
export const SYSTEM_FIELD_FORM_BUILDER_TYPE_RADIO = 'radio'
export const SYSTEM_FIELD_FORM_BUILDER_TYPE_DATE = 'date'
export const SYSTEM_FIELD_FORM_BUILDER_TYPE_FILE = 'file'
